import type { AcquisitionChannel, ManualIntakeUpdatePayload } from '@/api/lcCrm'

export const ACQUISITION_CHANNEL_LABELS: Record<AcquisitionChannel, string> = {
  WEBSITE: '홈페이지',
  REFERRAL: '소개',
  COLD_DM: '콜드DM',
  IN_PERSON: '대면',
  EXPO: '박람회',
  PHONE_DIRECT: '전화 직접',
  OTHER: '기타',
}

export function acquisitionChannelLabel(value?: AcquisitionChannel | null): string {
  return value ? ACQUISITION_CHANNEL_LABELS[value] : '미기록'
}

/** Unchanged values stay absent so editing a name or note preserves the recorded channel. */
export function acquisitionChannelPatch(
  initial: AcquisitionChannel | null | undefined,
  next: AcquisitionChannel | undefined,
): Pick<ManualIntakeUpdatePayload, 'acquisitionChannel' | 'clearAcquisitionChannel'> {
  if ((initial ?? undefined) === next) return {}
  return next ? { acquisitionChannel: next } : { clearAcquisitionChannel: true }
}

export function isAcquisitionChannel(value: unknown): value is AcquisitionChannel {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(ACQUISITION_CHANNEL_LABELS, value)
}
